import React from 'react';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
var getUrl = function (url) {
    if (!/^http/.test(url)) {
        return "http://" + url;
    }
    return url;
};
import s from './DeviationLink.scss';
var EditorDeviationLink = function (props) {
    var link = props.link, deviation = props.deviation, children = props.children, linkClass = props.linkClass;
    var isPublished = deviation.isPublished;
    return (React.createElement("div", { className: s['link'] },
        link && (React.createElement("a", { href: getUrl(link.url), rel: "nofollow noopener" }, children)),
        !link && isPublished && (React.createElement(DeviationLink, { deviation: deviation, className: linkClass }, children)),
        !link && !isPublished && children));
};
EditorDeviationLink.displayName = 'EditorDeviationLink';
export default EditorDeviationLink;
//# sourceMappingURL=DeviationLink.js.map